
import Api from '@/services/Index';

const create = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/create', formData);
}

const downloadCourseSchedule = async (id, lang, semester_id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang.toUpper()
    };
    if (semester_id) {
        data.semester_id = semester_id;
    }
    return Api.post('/student/documents/course-schedule/' + id, data, { responseType: 'arraybuffer' });
}
const mediumOfInstruction = async (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = { language: lang.toUpper() };
    return Api.post('/student/documents/medium-of-instruction/' + id, formData, { responseType: 'arraybuffer' });
}
const downloadDispatchPostponement = async (id, lang, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = {
        language: lang.toUpper(),
        ...data
    }
    return Api.post('/student/documents/dispatch-postponement/' + id, formData, { responseType: 'arraybuffer' });
}

const downloadExamSchedule = async (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = { language: lang.toUpper() };
    return Api.post('/student/documents/exam-schedule/' + id, formData, { responseType: 'arraybuffer' });
}

const downloadSchoolCertificate = async (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = { language: lang.toUpper() };
    return Api.post('/student/documents/school-certificate/' + id, formData, { responseType: 'arraybuffer' });
}

const downloadLanguageProficiency = async (id, lang, note = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = { language: lang.toUpper()};
    if (note) {
        formData.note = note;
    }
    return Api.post('/student/documents/language-proficiency/' + id, formData, { responseType: 'arraybuffer' });
}
const downloadLanguageProficiencytr = async (id, lang, note = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = { language: lang.toUpper()};
    if (note) {
        formData.note = note;
    }
    return Api.post('/student/documents/turkish-language-proficiency/' + id, formData, { responseType: 'arraybuffer' });
}

const downloadEnglishPlacementExam = async (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = { language: lang.toUpper() };
    return Api.post('/student/documents/english-placement-exam/' + id, formData, { responseType: 'arraybuffer' });
}

const downloadMilitaryStatus = async (id, lang, note = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = { language: lang.toUpper(), note };
    return Api.post('/student/documents/military-status/' + id, formData, { responseType: 'arraybuffer' });
}

const downloadNewPassword = async (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = { language: lang.toUpper() };
    return Api.post('/student/documents/password/' + id, formData, { responseType: 'arraybuffer' });
}

const downloadPrepTranscript = async (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = { language: lang.toUpper() };
    return Api.post('/student/documents/prep-transcript/' + id, formData, { responseType: 'arraybuffer' });
}

const downloadStudentCertificate = async (id, lang, document_number = null, note = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang.toUpper()
    };
    if (document_number) {
        data.document_number = document_number;
    }
    if (note) {
        data.note = note;
    }
    return Api.post('/student/documents/student-certificate/' + id, data, { responseType: 'arraybuffer' });
}

const downloadTranscript = async (id, lang, semester_id = null, note = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang.toUpper()
    };
    if (semester_id) {
        data.semester_id = semester_id;
    }
    if (note !== null && note !== undefined) {
        data.note = note;
    }
    return Api.post('/student/documents/transcript/' + id, data, { responseType: 'arraybuffer' })
}

const downloadWelcomeLetter = async (studentNumber, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = { language: lang.toUpper() };
    return Api.post('/student/documents/welcome/' + studentNumber, formData, { responseType: 'arraybuffer' });
}

const downloadGpaControl = async (id, config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/documents/gpa-control/' + id, { ...config, responseType: 'arraybuffer' });
}

const downloadDiploma = (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/diploma/' + id, formData, { responseType: 'arraybuffer' });
}
const downloadSecondDiploma = (id, ) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('student/documents/diploma-second-copy/' + id, null, { responseType: 'arraybuffer' });
}

const downloadDiplomaAnnexes = (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang.toUpper()
    };
    return Api.post('/student/documents/diploma-supplement/' + id, data, { responseType: 'arraybuffer' });
}

const downloadTemporaryGraduation = (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/temporary-graduation-certificate/' + id, null, { responseType: 'arraybuffer' });
}

const downloadMinorCertificate = (id, formData = null, response_type = "arraybuffer") => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/minor-certificate/' + id, formData, { responseType: response_type });
}

const downloadAttendanceList = (section_ID,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/attendance-list/' + section_ID, data, { responseType: 'arraybuffer' });
}

const downloaWeeklydAttendanceList = (section_ID) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/documents/weekly-attendance-list/' + section_ID, { responseType: 'arraybuffer' });
}

const downloadExamReport = (exam_ID = '', classroom = '') => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/exam-report/' + exam_ID + '/' + classroom, null, { responseType: 'arraybuffer' });
}

const downloadExamListReport = (exam_ID) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/exam-report-list/' + exam_ID, null, { responseType: 'arraybuffer' });
}

const downloadRegistrationForm = (studentProgramId, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/registration-form/' + studentProgramId, formData, { responseType: 'arraybuffer' });
}

const downloadGpaStudentExcel = (studentProgramId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/documents/gpa-control-excel-export/' + studentProgramId, { responseType: 'arraybuffer' });
}

const downloadDisciplineRegistry = async (id, lang, note) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    let data = {
        language: lang.toUpper()
    };
    if (note) {
        data.note = note;
    }
    return Api.post('/student/documents/discipline/' + id, data, {
        responseType: 'arraybuffer'
    })
}

const downloadExamReportAllSection = (examId = '', classroom = '') => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/student/documents/all-section-exam-report/' + examId + '/' + classroom, null, { responseType: 'arraybuffer' })
}

const downloadDiplomaNotebook = (studentProgramId, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;

    let data = {
        language: lang.toUpper()
    };

    return Api.post('/student/documents/diploma-notebook/' + studentProgramId, data, { responseType: 'arraybuffer' });
}
const LeavingReport = async (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang.toUpper()
    };

    return Api.post("/student/documents/leaving-report/" + id, data, { responseType: 'arraybuffer' });
}

const alumniReport = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("student/documents/alumni-information-form/" + id, null, { responseType: 'arraybuffer' });
}

const downloadStudentCourseSchedule = (studentProgramId, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = { language: lang.toUpper() };
    return Api.post('/student/documents/course-schedule/' + studentProgramId, formData, { responseType: 'arraybuffer' });
}

const downloadStudentExamSchedule = (studentProgramId, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = { language: lang.toUpper() };
    return Api.post('/student/documents/exam-schedule/' + studentProgramId, formData, { responseType: 'arraybuffer' });
}
const twoCopiesWetSignature = (studentProgramId,formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/diploma/' + studentProgramId,formData,{ responseType: 'arraybuffer' });
}
const educationInformationReporting = () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/educations/excel-report',{ responseType: 'arraybuffer' });
}

const getFinanceDocument = (studentProgramId,lang,document_number) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang.toUpper()
    };
    if (document_number) {
        data.document_number = document_number;
    }
    return Api.post(`/student/documents/tuition-fee/${studentProgramId}`, data, { responseType: 'arraybuffer' });
}

const downloadVisaSupportLetter = async (studentProgramId, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang.toUpper()
    };
    return Api.post('/student/documents/visa-support-letter/' + studentProgramId, data, { responseType: 'arraybuffer' });
}

const downloadRegistrationCompletedCertificate = async (studentProgramId, lang, documentNumber = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang.toUpper()
    };
    if (documentNumber) {
        data.document_number = documentNumber;
    }
    return Api.post('/student/documents/registration-completed-certificate/' + studentProgramId, data, { responseType: 'arraybuffer' });
}

const downloadMinorHighHonorCertificate = async (studentProgramId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/documents/minor-high-honor-certificate/' + studentProgramId, { responseType: 'arraybuffer' });
}

const downloadSuccessStatus = async (studentProgramId, lang, documentNumber = null, semesterId = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang.toUpper()
    };
    if (documentNumber) {
        data.document_number = documentNumber;
    }
    if (semesterId) {
        data.semester_id = semesterId;
    }
    return Api.post('/student/documents/success-status/' + studentProgramId, data, { responseType: 'arraybuffer' });
}

const downloadStudentSituationCertificate = async (studentProgramId, lang, documentNumber = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang.toUpper()
    };
    if (documentNumber) {
        data.document_number = documentNumber;
    }
    return Api.post('/student/documents/student-situation-certificate/' + studentProgramId, data, { responseType: 'arraybuffer' });
}

const downloadPrepGradeCertificate = async (studentProgramId, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang.toUpper()
    };
    return Api.post('/student/documents/prep-grade-certificate/' + studentProgramId, data, { responseType: 'arraybuffer' });
}

const downloadAcceptanceLetter = async (studentProgramId, lang, note = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang ? lang.toUpper() : 'TR'
    };
    if (note) {
        data.note = note;
    }
    return Api.post('/student/documents/acceptance-letter/' + studentProgramId, data, { responseType: 'arraybuffer' });
}

const downloadEkcCertificate = async (studentProgramId, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang ? lang.toUpper() : 'TR'
    };
    return Api.post('/student/documents/ekc-certificate/' + studentProgramId, data, { responseType: 'arraybuffer' });
}

const downloadGradeEvaluationList = (sectionId, responseType) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        response_type: responseType
    };
    return Api.post('/student/documents/grade-evaluation-list/' + sectionId, data, { responseType: 'arraybuffer' });
}

const downloadGradeEvaluationReport = (sectionId, responseType) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        response_type: responseType
    };
    return Api.post('/student/documents/grade-evaluation-report/' + sectionId, data, { responseType: 'arraybuffer' });
}

const downloadTransferCertificate = async (studentProgramId, lang, documentNumber = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang ? lang.toUpper() : 'GE'
    };
    if (documentNumber) {
        data.document_number = documentNumber;
    }
    return Api.post('/student/documents/transfer-certificate/' + studentProgramId, data, { responseType: 'arraybuffer' });
}

const downloadGraduationCertificate = async (studentProgramId, lang, documentNumber = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang ? lang.toUpper() : 'GE'
    };
    if (documentNumber) {
        data.document_number = documentNumber;
    }
    return Api.post('/student/documents/graduation-certificate/' + studentProgramId, data, { responseType: 'arraybuffer' });
}

const downloadTranscriptCertificate = async (studentProgramId, lang, documentNumber = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang ? lang.toUpper() : 'GE'
    };
    if (documentNumber) {
        data.document_number = documentNumber;
    }
    return Api.post('/student/documents/transcript-certificate/' + studentProgramId, data, { responseType: 'arraybuffer' });
}

const downloadCompensationCertificate = async (studentProgramId, lang, documentNumber = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang ? lang.toUpper() : 'GE'
    };
    if (documentNumber) {
        data.document_number = documentNumber;
    }
    return Api.post('/student/documents/compensation-certificate/' + studentProgramId, data, { responseType: 'arraybuffer' });
}

const downloadCovidCompensationCertificate = async (studentProgramId, lang, documentNumber = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang ? lang.toUpper() : 'GE'
    };
    if (documentNumber) {
        data.document_number = documentNumber;
    }
    return Api.post('/student/documents/covid-compensation-certificate/' + studentProgramId, data, { responseType: 'arraybuffer' });
}

const downloadBlsFirstAidCertificate = async (studentProgramId, lang, documentNumber = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang ? lang.toUpper() : 'GE'
    };
    if (documentNumber) {
        data.document_number = documentNumber;
    }
    return Api.post('/student/documents/bls-first-aid-certificate/' + studentProgramId, data, { responseType: 'arraybuffer' });
}

const downloadFirstAttemptCertificate = async (studentProgramId, lang, documentNumber = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang ? lang.toUpper() : 'GE'
    };
    if (documentNumber) {
        data.document_number = documentNumber;
    }
    return Api.post('/student/documents/first-attempt-certificate/' + studentProgramId, data, { responseType: 'arraybuffer' });
}

const downloadClinicalPracticeInternshipCertificate = async (studentProgramId, lang, documentNumber = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang ? lang.toUpper() : 'GE'
    };
    if (documentNumber) {
        data.document_number = documentNumber;
    }
    return Api.post('/student/documents/clinical-practice-internship-certificate/' + studentProgramId, data, { responseType: 'arraybuffer' });
}

const downloadSectionExamReportList = (sectionId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/section-exam-report-list/' + sectionId, null, { responseType: 'arraybuffer' });
}

export default {
    create,
    getFinanceDocument,
    downloadVisaSupportLetter,
    downloadRegistrationCompletedCertificate,
    downloadMinorHighHonorCertificate,
    downloadCourseSchedule,
    downloadDispatchPostponement,
    downloadExamSchedule,
    downloadSchoolCertificate,
    downloadLanguageProficiency,
    downloadEnglishPlacementExam,
    downloadMilitaryStatus,
    downloadNewPassword,
    downloadPrepTranscript,
    downloadStudentCertificate,
    downloadTranscript,
    downloadWelcomeLetter,
    downloadGpaControl,
    downloadDiploma,
    downloadDiplomaAnnexes,
    downloadTemporaryGraduation,
    downloadMinorCertificate,
    downloadAttendanceList,
    downloadExamReport,
    downloadExamListReport,
    downloadRegistrationForm,
    downloadGpaStudentExcel,
    downloaWeeklydAttendanceList,
    downloadDisciplineRegistry,
    downloadExamReportAllSection,
    downloadDiplomaNotebook,
    LeavingReport,
    alumniReport,
    downloadSecondDiploma,
    downloadStudentCourseSchedule,
    downloadStudentExamSchedule,
    twoCopiesWetSignature,
    educationInformationReporting,
    downloadLanguageProficiencytr,
    mediumOfInstruction,
    downloadSuccessStatus,
    downloadStudentSituationCertificate,
    downloadPrepGradeCertificate,
    downloadAcceptanceLetter,
    downloadEkcCertificate,
    downloadGradeEvaluationList,
    downloadGradeEvaluationReport,
    downloadTransferCertificate,
    downloadGraduationCertificate,
    downloadTranscriptCertificate,
    downloadCompensationCertificate,
    downloadCovidCompensationCertificate,
    downloadBlsFirstAidCertificate,
    downloadFirstAttemptCertificate,
    downloadClinicalPracticeInternshipCertificate,
    downloadSectionExamReportList
}



